export const GET_POINTS_OF_SALE = 'GET_POINTS_OF_SALE';
export const IS_LOADING_GET_POINTS_OF_SALE = 'IS_LOADING_GET_POINTS_OF_SALE';
export const SELECT_POINT_OF_SALE = 'SELECT_POINT_OF_SALE';
export const CREATE_POINT_OF_SALE = 'CREATE_POINT_OF_SALE';
export const UPDATE_POINT_OF_SALE = 'UPDATE_POINT_OF_SALE';
export const REMOVE_POINT_OF_SALE = 'REMOVE_POINT_OF_SALE';
